module.exports = __webpack_public_path__ + "static/media/bill-invoice-inactive.12cdb95e.svg";